import styled from "@emotion/styled";

import logo from "src/assets/images/new_logo_white.svg";
import { i18n, mediaQuery, openContactModal } from "src/common";
import config from "src/config";
import { colors, header, headerWidget } from "src/theme";
import { Flex } from "../grid";
import { Text } from "../typography";
import { HeaderWidget } from "./headerWidget.layout";
// import { HeaderWidgetGiveaway } from "./headerWidget.layout";

const HeaderStyle = styled.header({
  backgroundColor: colors.primary,
  height: `${header.mobileHeight}px`,
  position: 'fixed',
  width: '100%', 
  top: 0,
  left: 0,
  zIndex: 100,

  [mediaQuery('laptopL')]: {
    height: `${header.height}px`,
  },
})

const TextStyle = styled(Text)({
  color: colors.white
})

// TODO: Add back the widget when we have the new giveaway
// const WidgetStyle = styled(HeaderWidgetGiveaway)({
//   height: `${headerWidget.mobileHeight}px`,

//   [mediaQuery('laptopL')]: {
//     height: `${headerWidget.height}px`,
//   },
// })

const LinkStyle = styled.a({
  cursor: 'pointer',
  display: 'inline-flex',

  '&:hover': {
    opacity: 0.6
  },

  '&:focus-visible': {
    outline: `2px solid ${colors.white}`,
    outlineOffset: '4px',
  },
})

const ButtonStyle = styled.button({
  cursor: 'pointer',
  background: 'none',
  border: 0,
  padding: 0,
  font: 'inherit',

  '&:hover': {
    opacity: 0.6
  },

  '&:focus-visible': {
    outline: `2px solid ${colors.white}`,
    outlineOffset: '4px',
  },
})

const LogoStyle = styled.img({
  height: '24px'
})

const ContainerStyle = styled(Flex)({
  height: `${header.mobileHeight - headerWidget.mobileHeight}px`,
  padding: '24px',

  [mediaQuery('laptopL')]: {
    width: '1150px',
    margin: '0 auto',
    padding: 0,
    height: `${header.height - headerWidget.height}px`,
  },
})

export const Header = () => {
  const bannerMessage: string = '';
  return (
    <HeaderStyle>
      {/* <WidgetStyle /> */}
      <ContainerStyle justify='space-between' align='center' gap={8}>
        <LinkStyle href={config.REACT_APP_KOMPARE_HOME}><LogoStyle src={logo} alt="kompare.hr" /></LinkStyle>
        <ButtonStyle type="button" onClick={() => openContactModal()}>
          <TextStyle as="span" type="base" bold>{i18n.t('layout.header.requestAgent')}</TextStyle>
        </ButtonStyle>
      </ContainerStyle>
      <HeaderWidget message={bannerMessage} />
    </HeaderStyle>
  )
};
